export default __webpack_public_path__ + "static/media/G0150.Paediatric_Basic_Life_Support_Algorithm_GS.1657018680000.27a4481c.jpg";